<payee-form-field>
  <input
    payee-input
    placeholder="Tömeges feltöltés neve"
    [formControl]="bulk_upload_name"
  />
</payee-form-field>
